import React from 'react';
import { ChevronDown } from 'lucide-react';

const ProcessSteps = () => {
  const steps = [
    {
      number: '1',
      title: ' פגישת ייעוץ ראשונית',
      description: 'פגישה אישית ומעמיקה להבנת הצרכים, הסברים על ייפוי כוח מתמשך והשלכותיו.',
      freeLabel: true
    },
    {
      number: '2',
      title: 'אבחון המצב האישי והמשפטי',
      description: 'ניתוח מקיף של מצבך האישי, הבריאותי והמשפחתי כדי להתאים את ייפוי הכוח לרצונותיך.'
    },
    {
      number: '3',
      title: 'גיבוש ההנחיות ובחירת מיופה הכוח',
      description: 'סיוע בבחירת מיופה הכוח ובניסוח הנחיות ברורות, כולל אפשרות להנחיות ספציפיות ומפורטות.'
    },
    {
      number: '4',
      title: 'עריכת ייפוי הכוח',
      description: 'עריכה וחתימה של ייפוי הכוח המתמשך בנוכחות עורך דין מוסמך,כולל הסברים ותמיכה בכל שלב.'
    },
    {
        number: '5',
        title: 'הפקדה באפוטרופוס הכללי',
        description: 'הפקדת ייפוי הכוח המתמשך במשרד המשפטים עדי להבטיח את תוקפו בעת הצורך.'
       
      }
  ];

  return (
    <div className="max-w-2xl mx-auto px-4">
         <h2 className="text-3xl font-bold text-center mb-16">שלבים בתהליך</h2>
      <div className="space-y-12">
        {steps.map((step, index) => (
          <div key={index} className="flex flex-col items-center">
            {/* Step Number Circle */}
            <div className="relative mb-2">
              <div className="w-16 h-16 rounded-full bg-gradient-to-r  from-[#97a9b6] to-[#35434e] text-white flex flex-col items-center justify-center shadow-lg">
                <span className="text-sm font-bold">שלב</span>
                <span className="text-xl font-bold">{step.number}</span>
              </div>
            </div>

            {/* Title and Description */}
            <div className="text-center mt-2 relative">
              <h3 className="text-xl font-bold mb-2 flex items-center justify-center">
                {step.title}
                {step.freeLabel && (
                  <div className="relative mr-3">
                    <div className="absolute inset-0 bg-green-500 blur-sm opacity-50"></div>
                    <div className="bg-gradient-to-r from-green-500 to-emerald-500 text-white px-4 py-1 rounded-full relative">
                      <span className="text-sm font-bold animate-pulse">ללא עלות!</span>
                      {/* <div className="absolute -top-1 -right-1 w-2 h-2 bg-yellow-400 rounded-full"></div>
                      <div className="absolute -bottom-1 -left-1 w-2 h-2 bg-yellow-400 rounded-full"></div> */}
                    </div>
                  </div>
                )}
              </h3>
              <p className="text-gray-600">{step.description}</p>
            </div>

            {/* Arrow Down */}
            {index < steps.length - 1 && (
              <div className="mt-6">
                <ChevronDown className="w-8 h-8 text-brand-600" />
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default ProcessSteps;